<template>
  <div>
    <Card>
      <Row align="middle" type="flex">
        <Col span="2">
          <h3>{{decodeURIComponent($route.query.desk_name)}}</h3>
        </Col>
        <!-- <Button type="info"
                @click="add">新增</Button> -->
      </Row>
      <TablePaginate :columns="columns"
                     :data="seats"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_seat_index_933')">
      <Form ref="category"
            :model="seat"
            :label-width="80">
        <Form-item :label="$t('pages_seat_index_934')"
                   prop="name">
          <Input type="text"
                 v-model="seat.name" />
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="bindStickerShow"
           @on-ok="handleBindSticker"
           :title="$t('pages_seat_index_935')">
          <Input type="text"
                 v-model="code" />
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { downloadImgInTable, tableAvatar2 } from '@/libs/table-render'
// deleteButtonInTable, editorButtonInTable,
export default {
  components: {
    TablePaginate,
  },
  data () {
    return {
      modalShow: false,
      formType: '',
      bindStickerShow: false,
      code: '',
      bindStickerSeat: null,
      columns: [
        {
          title: 'ID',
          width: 100,
          key: 'id',
          align: 'center'
        },
        {
          title: i18n.t('pages_seat_index_936'),
          key: 'qr_code_content',
          width: 400,
          align: 'center'
        },
        {
          title: i18n.t('pages_seat_index_937'),
          key: 'qr_code_url',
          align: 'center',
          width: 200,
          render: (h, params) => {
            return tableAvatar2(h, params.row.qr_code_url)
          }
        },
        {
          title: i18n.t('pages_balance_transaction_index_177'),
          align: 'center',
          width: 200,
          key: 'created_at'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            const children = []
            // children.push(deleteButtonInTable(this, h, params))
            // children.push(editorButtonInTable(this, h, params))
            if (params.row.qr_code_url) {
              children.push(downloadImgInTable(
                this,
                h,
                {
                  title: i18n.t('pages_seat_index_938'),
                  url: params.row.qr_code_url
                }
              ))
            }
            // if (params.row.scan_qr_url == null) {
            //   children.push(commonButtonInTable(this,
            //     h,
            //     'info',
            //     '绑定桌台码',
            //     this.showBindStickerModel,
            //     [params.row]))
            // }
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index({
      fresh_desk_id: this.$route.query.fresh_desk_id
    })
  },
  computed: {
    ...mapState('seat', ['seat', 'seats', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('seat', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'bindSticker'
    ]),
    ...mapMutations('seat', ['changeQuery']),
    showBindStickerModel (seat) {
      this.bindStickerSeat = seat
      this.bindStickerShow = true
    },
    handleBindSticker () {
      if (this.bindStickerSeat) {
        this.bindSticker({
          id: this.bindStickerSeat.id,
          code: this.code
        })
      }
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update({
          ...this.seat,
          fresh_desk_id: this.$route.query.fresh_desk_id
        })
      } else if (this.formType === 'new') {
        await this.create({
          ...this.seat,
          fresh_desk_id: this.$route.query.fresh_desk_id
        })
      }
      this.modalShow = false
    },
  }
}
</script>
